import { inject, Pipe, PipeTransform } from '@angular/core';
import { SettingsService } from '@app/core/config/settings.service';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'setting',
  pure: false
})
export class SettingPipe implements PipeTransform {
  private readonly settingService = inject(SettingsService);
  private readonly translate = inject(TranslateService);

  transform(key: string, addLanguageSuffix?: boolean): any  {
    if (addLanguageSuffix) {
      key += '.' + this.translate.getCurrentLang();
    }

    return this.settingService.get(key);
  }
}
